/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoryWithFamilyResource
 */
export interface CategoryWithFamilyResource {
    /**
     * 
     * @type {string}
     * @memberof CategoryWithFamilyResource
     */
    familyId: string;
    /**
     * 
     * @type {string}
     * @memberof CategoryWithFamilyResource
     */
    categoryId: string;
}

/**
 * Check if a given object implements the CategoryWithFamilyResource interface.
 */
export function instanceOfCategoryWithFamilyResource(value: object): value is CategoryWithFamilyResource {
    if (!('familyId' in value) || value['familyId'] === undefined) return false;
    if (!('categoryId' in value) || value['categoryId'] === undefined) return false;
    return true;
}

export function CategoryWithFamilyResourceFromJSON(json: any): CategoryWithFamilyResource {
    return CategoryWithFamilyResourceFromJSONTyped(json, false);
}

export function CategoryWithFamilyResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryWithFamilyResource {
    if (json == null) {
        return json;
    }
    return {
        
        'familyId': json['familyId'],
        'categoryId': json['categoryId'],
    };
}

export function CategoryWithFamilyResourceToJSON(value?: CategoryWithFamilyResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'familyId': value['familyId'],
        'categoryId': value['categoryId'],
    };
}

